import React, {useCallback, useState} from "react";
import './Register.css';
import {Button, Heading, Columns, Table} from 'react-bulma-components';
import {auth, db} from '../firestore';
import {sendEmailVerification, createUserWithEmailAndPassword, signInWithPhoneNumber, getAuth, RecaptchaVerifier} from "firebase/auth";
import { addDoc, collection, doc, GeoPoint, setDoc } from "firebase/firestore";
import {Link, useNavigate} from "react-router-dom";

const titleStyle = {
    color: 'red',
    padding: '0px -5px 0px -5px',
    margin: '0px 0px 10px 0px',
    fontSize: '5em',
};

// Client ID
// 865339852201-oqdmqjo4vlpmudli4e1q63aek2kjgmuq.apps.googleusercontent.com

// Client Secret
// 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

function RegisterBox() {

    const [inputs, setInputs] = useState({});
    const [userType, setUserType] = useState({});

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))
    }

    const handleChange2 = (event) => {
        const name = event.target.name;
        const uType = event.target.value
        console.log(uType)
        setUserType(values => ({...values, [name]: uType}))
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (userType.usertype === undefined) {
            userType.usertype = "NormalUser"
        }

        if (inputs.homeaddress === undefined) {
            inputs.homeaddress = ""
        }

        if (inputs.hospitalfire === undefined) {
            inputs.hospitalfire = ""
        }

        console.log(inputs.username);
        console.log(inputs.pass);
        console.log(inputs.confirmpass);
        console.log(inputs.phone);
        console.log(userType.usertype);
        console.log(inputs.homeaddress);
        console.log(inputs.hospitalfire);

        if (inputs.pass === inputs.confirmpass) {
            createUserWithEmailAndPassword(auth, inputs.username, inputs.pass)
                .then((userCredential) => {
                    console.log("Signing In")

                    const userPoint = new GeoPoint(23.546981, 90.5354898)

                    setDoc(doc(db, "Users", inputs.username), {
                            UserName: inputs.username,
                            Email: inputs.username,
                            Phone: inputs.phone,
                            HomeAddressText: inputs.homeaddress,
                            HomeAddressLoc: userPoint,
                            TypeofUser:  userType.usertype
                    });

                    console.log("About to get User")
                    const user = userCredential.user;
                    document.cookie = ("Username =" + user["email"]);
                    console.log(readCookie("Username"))

                    const auth = getAuth();
                    sendEmailVerification(auth.currentUser)
                        .then(() => {
                            console.log("Email verification sent")
                        });

                    alert("Successfully registered. Click on the EHET Logo to back to the homepage")

                    window.location.assign("https://ehet.netlify.app/")

                    // window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
                    //     'size': 'normal',
                    //     'callback': (response) => {
                    //         // reCAPTCHA solved, allow signInWithPhoneNumber.
                    //         // ...
                    //     },
                    //     'expired-callback': () => {
                    //         // Response expired. Ask user to solve reCAPTCHA again.
                    //         // ...
                    //     }
                    // }, auth);

                    // recaptchaVerifier.render().then((widgetId) => {
                    //     window.recaptchaWidgetId = widgetId;
                    // });

                    // const recaptchaResponse = grecaptcha.getResponse(recaptchaWidgetId);

                    // const phoneNumber = inputs.phone;
                    // const appVerifier = window.recaptchaVerifier;

                    // signInWithPhoneNumber(auth, phoneNumber, appVerifier)
                    //     .then((confirmationResult) => {
                    //         // SMS sent. Prompt user to type the code from the message, then sign the
                    //         // user in with confirmationResult.confirm(code).
                    //         window.confirmationResult = confirmationResult;
                    //         // ...
                    //     }).catch((error) => {
                    //     // Error; SMS not sent
                    //     // ...
                    // });

                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode, ">", errorMessage)
                    if (errorCode === "auth/email-already-in-use") {
                        alert("This account already exists")
                    } else if (errorCode === "auth/invalid-email") {
                        alert("Email not in correct format")
                    } else if (errorCode === "auth/weak-password") {
                        alert("Use a stronger password with 6 or more characters.")
                    }
                });
        } else {
            alert("Passwords do not match.")
        }
    }

    return (
        <div className={"fullCardLayoutStyle"}
             style={{width: "50%", minHeight: "800px", minWidth:"320px", height:"85vh", position: "absolute", left: "25%", top: "7.5%", textAlign: "center",}}>
            <Link to="/"><h1 style={titleStyle}><b>EHET</b></h1></Link>
            <form onSubmit={handleSubmit}>
                <label><b>Email ID</b></label>
                <p><input
                        type="text"
                        className={"inputField"}
                        name="username"
                        value={inputs.username || ""}
                        onChange={handleChange}
                    /></p>
                <p><label><b>Password</b></label></p>
                <p><input
                        type="password"
                        className={"inputField"}
                        name="pass"
                        value={inputs.pass || ""}
                        onChange={handleChange}
                    /></p>
                <label><b>Confirm Password</b></label>
                <p><input
                    type="password"
                    className={"inputField"}
                    name="confirmpass"
                    value={inputs.confirmpass || ""}
                    onChange={handleChange}
                /></p>
                <label><b>Phone</b></label>
                <p><input
                    type="text"
                    className={"inputField"}
                    name="phone"
                    value={inputs.phone || ""}
                    onChange={handleChange}
                /></p>
                <label><b>Type of Account</b></label>
                <p>
                    <select value={userType.value} name="usertype" onChange={handleChange2}>
                        <option value="NormalUser">Normal User</option>
                        <option value="Medical">Medical Personnel</option>
                        <option value="Fire">Fire Service Personnel</option>
                        <option value="Admin">Administrator</option>
                    </select>
                </p><br/>
                <label><b>Home Address<br/><h6 style={{fontSize: 'small'}}>(For Normal User Only)</h6></b></label>
                <p><input
                    type="text"
                    className={"inputField"}
                    name="homeaddress"
                    value={inputs.homeaddress || "N/A"}
                    onChange={handleChange}
                    defaultValue={ "N/A" }
                /></p>
                <label><b>Assigned Hospital/Fire Station</b><br/><h6 style={{fontSize: 'small'}}>(Leave Empty if Normal User)</h6></label>
                <p><input
                    type="text"
                    className={"inputField"}
                    name="hospitalfire"
                    value={inputs.hospitalfire || "N/A"}
                    onChange={handleChange}
                    defaultValue={ "N/A" }
                /></p>
                <br />
                <p><Button color="info" type="submit" onClick={handleSubmit}>Submit</Button></p>
            </form>
        </div>
    );

}

export default RegisterBox;
